import update from 'react-addons-update';

import { store, addReducer, addStorePart } from './store';

/**
 * Constants
 */
export const configConst = {
    STORE_PART: 'omfe-core-data:config',

    SET_CONFIG_ACTION: 'OMFE_CORE_DATA_UPDATE_CONFIG_ACTION',
};

/**
 * Store Part with Initial Config
 */
addStorePart(configConst.STORE_PART, { });


/**
 * Reducers
 */
addReducer(configConst.STORE_PART, configConst.SET_CONFIG_ACTION, (prevState = {}, action) =>
    update(prevState, { $merge: action.config }));

/**
 * setConfig - Update Config (action creator)
 * - updates application configuration
 * - performs shallow merge on store config sub-object
 *
 * @param  {obj}  config        new configuration
 * @return {obj}                action
 */
export function setConfig(config = {}) {
    return (typeof config !== 'object' || config === null) && { type: `NONE_${Date.now()}` } || {
        type: configConst.SET_CONFIG_ACTION,
        config,
    };
}

/**
 * Inherits Defaults From Global OMFECONFIG Variable
 */
/* global OMFECONFIG: true */
store.dispatch(setConfig(typeof OMFECONFIG === 'object' && OMFECONFIG !== null && OMFECONFIG || {}));



// WEBPACK FOOTER //
// ./src/OMFECore/config-manager.js